import { useState, useEffect, useRef } from 'react';
export const useAlertDialogState = () => {
  const [isAlertDialogActive, setIsAlertDialogActive] = useState(false);
  const observerRef = useRef(null);
  useEffect(() => {
    const checkAlertDialog = () => {
      const alertDialog = document.querySelector('[role="alertdialog"]');
      if (!alertDialog) return;
      const alertDialogParent = alertDialog.parentElement;
      const isVisible = alertDialogParent && window.getComputedStyle(alertDialogParent).display !== 'none';
      setIsAlertDialogActive(!!isVisible);
    };
    // Initial check
    checkAlertDialog();
    // Create and store observer in ref
    observerRef.current = new MutationObserver(checkAlertDialog);
    observerRef.current.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);
  return isAlertDialogActive;
};